import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';

export const LoadingSpinnerButton = (props) => {
  return (
    <CircularProgress {...props}/>
  )
}

LoadingSpinnerButton.defaultProps = {
  size: 24,
  thickness: 7
}

export const LoadingSpinnerPage = ({className, ...other}) => {
  const Container = styled.div`
    display: flex;
    flex: 1 0 auto;
    justify-content: center;
    align-items: center;
  `

  return (
    <Container className={className}>
      <CircularProgress {...other}/>
    </Container>
  )
}

LoadingSpinnerPage.defaultProps = {
  size: 68,
  thickness: 5
}
